// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"auth__wrapper--RgFwAu"};